import { render, staticRenderFns } from "./goodsRowSetting.vue?vue&type=template&id=52589793&scoped=true&"
import script from "./goodsRowSetting.vue?vue&type=script&lang=js&"
export * from "./goodsRowSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsRowSetting.vue?vue&type=style&index=0&id=52589793&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52589793",
  null
  
)

export default component.exports